exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".idUpload{background:#e9e9e9;padding:15px;margin-bottom:10px}.idUpload input[type=text]{margin-bottom:5px;margin-bottom:10px}.idUpload input[type=file]{margin-bottom:10px}.idUpload p{margin-bottom:20px}.idUpload label{display:block;margin-bottom:5px}.identification{background:#fff;padding:15px;margin-bottom:20px}.idUpload .error{font-weight:700;margin-bottom:20px;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66182a78","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Checkout/Partials/Identification-upload.vue
// module id = N+Gy
// module chunks = 116